export default __webpack_public_path__ + "static/media/cash-coin.16abbdc0.svg";